import { Form, Formik, FormikValues } from "formik";
import moment from "moment";
import { useEffect, useRef, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import * as Yup from "yup";
import { StepperComponent } from "../../../../_metronic/assets/ts/components";
import { CODE, RESPONSE_MESSAGE } from "../../utils/Constant";
import { getAssignmentImplementById, saveAssignmentImplement, updateAssignmentImplement } from "../services/services";
import { exportAssignmentDecision } from "../../quan-ly-de-tai/de-tai/services/ExportServices";
import Step1 from "./Step1";
import Step2 from "./Step2";
import ButtonIn from "../../component/button-in-phieu";

interface Props {
  onHide: () => void;
  onRefresh: () => void;
  id?: string;
  isView?: boolean
}

const AddAssignmentImplementDialog = (props: Props) => {
  const { onHide, onRefresh, id, isView } = props;

  const stepperRef = useRef<HTMLDivElement | null>(null);
  const stepper = useRef<StepperComponent | null>(null);
  const formRef = useRef<any>(null);

  const [isSubmit, setIsSubmit] = useState<boolean>(false);
  const [selectedTopics, setSelectedTopics] = useState<any[]>([]);

  const validationSchema = Yup.object().shape({
    regisPeriod: Yup.object()
      .nullable()
      .test("required-if-no-id", "Vui lòng nhập thông tin!", function (value) {
        return !!id || !!value;
      }),
  });

  const updatePageData = async () => {
    try {
      let { data } = await getAssignmentImplementById(id!);
      if (data?.code === CODE.SUCCESS) {
        formRef.current?.setValues({
          ...formRef.current?.values,
          ...data?.data ?? {},
          regisPeriod: {
            id: data?.data?.regisPeriodId,
            name: data?.data?.regisPeriodName,
            year: data?.data?.regisPeriodYear
          }
        });
        setSelectedTopics(data?.data?.topics || []);
      }
    } catch (e) {
      toast.error(RESPONSE_MESSAGE.ERROR);
    }
  };

  useEffect(() => {
    if (id) {
      updatePageData();
    }
  }, [id]);

  useEffect(() => {
    if (!stepperRef.current) {
      return;
    }

    loadStepper();
  }, [stepperRef]);

  const loadStepper = () => {
    stepper.current = StepperComponent.createInsance(
      stepperRef.current as HTMLDivElement
    );
  };

  const getTitle = () => {
    let prefix = "";
    if (id) {
      prefix = "Cập nhật";
    } else {
      prefix = "Thêm mới";
    }

    return `${!isView ? prefix : ""} quyết định giao thực hiện`;
  };

  const prevStep = () => {
    if (!stepper.current) {
      return;
    }
    setIsSubmit(false);
    stepper.current.goPrev();
  };

  const submitStep = async (values: any, actions: FormikValues) => {
    if (!stepper.current) {
      return;
    }

    if (stepper.current.currentStepIndex !== stepper.current.totatStepsNumber && !isSubmit) {
      stepper.current?.goNext();
      setIsSubmit(true);
    } else if (isSubmit) {
      await handleSaveAssignmentImplement(values);
    }
  };

  const handleSaveAssignmentImplement = async (values: any) => {
    try {
      let submitData = {
        id: id,
        code: values?.code,
        regisPeriodId: values?.regisPeriod?.id,
        regisPeriodYear: values?.regisPeriodYear,
        decisionNumber: values?.decisionNumber,
        issueDay: values?.issueDay,
        issueMonth: values?.issueMonth,
        issueYear: values?.issueYear,
        implementationStartDay: values?.implementationStartDay,
        implementationStartMonth: values?.implementationStartMonth,
        implementationStartYear: values?.implementationStartYear,
        implementationEndDay: values?.implementationEndDay,
        implementationEndMonth: values?.implementationEndMonth,
        implementationEndYear: values?.implementationEndYear,
        implementationYear: values?.implementationEndYear,
        topics: values?.topics
      };
      let { data } = id ? await updateAssignmentImplement(submitData) : await saveAssignmentImplement(submitData);
      if (CODE.SUCCESS === data?.code) {
        toast.success(`${id ? "Cập nhật" : "Thêm"} quyết định giao thực hiện thành công`);
        onHide();
        onRefresh();
      } else {
        let errorMesage = data?.data?.[0]?.errorMessage ?? RESPONSE_MESSAGE.ERROR;
        toast.warn(errorMesage);
      }
    } catch (error) {
      console.error(error);
    }
  };


  const handleSubmitStep = () => {
    formRef.current?.handleSubmit();
  };

  return (
    <Modal
      centered
      show={true}
      onHide={onHide}
      size="xl"
      className="spaces h-calc-vh-50"
      scrollable
      backdrop="static"
    >
      <div
        ref={stepperRef}
        className="stepper stepper-links d-flex flex-column"
        id="kt_create_account_stepper"
      >
        <Modal.Header className="header-modal min-h-40px" closeButton>
          <Modal.Title className="py-4">{getTitle()}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="spaces p-0 bg-gray mxh-65vh science-council">
          <Formik<any>
            innerRef={formRef}
            enableReinitialize
            validationSchema={validationSchema}
            initialValues={{
              regisPeriod: null,
              code: "",
              regisPeriodYear: "",
              decisionNumber: "",
              issueDay: moment(new Date()).date(),
              issueMonth: moment(new Date()).month() + 1,
              issueYear: moment(new Date()).year(),
              implementationEndYear: "",
            }}
            onSubmit={submitStep}
          >
            {() => (
              <Form>
                {
                  (isView) ? <Step2 isView={isView} onRefresh={onRefresh} />
                    : <div className="card">
                      <div className="card-body p-0">
                        <div
                          ref={stepperRef}
                          className="stepper stepper-links d-flex flex-column"
                          id="kt_create_account_stepper"
                        >
                          <div className="stepper-nav">
                            <div
                              className="stepper-item current"
                              data-kt-stepper-element="nav"
                            >
                              <h3 className="stepper-title">1. Đợt đăng ký</h3>
                            </div>

                            <div className="stepper-item" data-kt-stepper-element="nav">
                              <h3 className="stepper-title">
                                2. Quyết định giao thực hiện
                              </h3>
                            </div>
                          </div>
                          <div id="kt_create_council-form" className="mx-auto w-100">
                            <div
                              className="current px-10 py-4"
                              data-kt-stepper-element="content"
                            >
                              <Step1 isView={isView} selectedTopics={selectedTopics}/>
                            </div>

                            <div data-kt-stepper-element="content" className="bg-gray px-10 py-4">
                              <Step2
                                isView={isView}
                                onRefresh={onRefresh}
                              />
                            </div>
                          </div>
                          </div>
                      </div>
                    </div>
                }
              </Form>
            )}
          </Formik>
        </Modal.Body>
        <Modal.Footer>
          <div className="d-flex flex-stack w-100">
            <div className="mr-2">
              <button
                onClick={prevStep}
                type="button"
                className="btn btn-primary me-3"
                data-kt-stepper-action="previous"
              >
                <i className="bi bi-chevron-bar-left m-0"></i>{""}
                Quay lại
              </button>
            </div>

            {isView ? (
              <>
              <ButtonIn 
                label="In biên bản"
                className="min-w-100px fw-bold ms-auto me-2"
                fetchExport={exportAssignmentDecision}
                params={{ id: id }}
              />

              <Button
                variant="secondary"
                className="min-w-75px fw-bold"
                onClick={onHide}
              >
                Đóng
              </Button>
              </>
            ) : (
              <div>
                <button
                  type="submit"
                  className="btn btn-lg btn-primary"
                  onClick={handleSubmitStep}
                >
                  <span className="indicator-label">
                    {isSubmit ? (
                      <span className="spaces px-10">Lưu </span>
                    ) : (
                      <>
                        <span>Tiếp theo </span>
                        <i className="bi bi-chevron-bar-right m-0"></i>
                      </>
                    )}
                  </span>
                </button>
              </div>
            )}
          </div>
        </Modal.Footer>
      </div>
    </Modal>
  );
};

export default AddAssignmentImplementDialog;
